<button [disabled]="process || disable"  mat-button class="mat-puc" type="submit" [ngClass]="class" (click)="_onPress()">
    <div class="puc-primary">
        <mat-spinner *ngIf="process"></mat-spinner>
        <span>{{label}}{{process?'...':''}}</span>
    </div>
  </button>